<script setup lang="ts">
const locale = await getLocale("ko", "resume_expired");

defineComponent({
    name: "ResumeExpired"
})

const emit = defineEmits(["init"])

onMounted(() => {
    emit("init");
})

</script>
<template>
    <div class="mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700 py-16">
        <div class="inset-0 flex items-center justify-center z-10  top-24 sm:top-0">
            <div class="modal-wrapper bg-white mx-4 text-center rounded-3xl mb-20 max-w-xl text-gray-700 shadow-xl px-6 md:px- py-6">
                <div class="pb-4 flex flex-col justify-center items-center">
                   <icons-clock></icons-clock>
                    <h1 class="text-2xl md:text-3xl font-semibold md:w-2/3 mx-auto mt-4">{{ locale.title }}</h1>
                </div>
                <div class="py-4 rounded-b-3xl">
                    <p v-html="locale.message"></p>
                    <p class="my-2" v-html="locale.redirect"></p>
                </div>
            </div>
        </div>
    </div>
</template>
